import Enum from '/@/modules/core/app/helpers/Enum';

export default class DeveloperLocale extends Enum {
  key!: string;
  value!: string;
  currency!: string;

  static DEVELOPER: DeveloperLocale = {
    key: 'en-DEV',
    value: 'Developer',
    currency: 'en-US'
  };
}
